function GaleriaCard({ foto }) {
  return (
    <div className="galeria-card">
      <img 
        src={foto.imagen} 
        alt="foto del destino" 
        loading="lazy"
      />
    </div>
  );
}

export default GaleriaCard;